import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import type { GetTaskWorkflowStepResponse } from "web_myplann/Infrastructure/Api/Api";
import { TaskSubtaskRow } from "web_myplann/Tasks/Components/TaskSubtaskRow";

type Props = {
	name: string;
	steps: GetTaskWorkflowStepResponse[];
	showDivider: boolean;
};

export const TaskPhaseBlock: FC<Props> = ({ name, steps, showDivider }) => {
	return (
		<Box borderBottom={showDivider ? 1 : 0} borderColor="surface.border">
			<Typography
				variant="bodyStrong"
				px={1.6}
				pt={1.2}
				pb={0.6}
				component="div"
			>
				{name}
			</Typography>
			{steps.map((step) => (
				<TaskSubtaskRow key={step.taskWorkflowStepID} data={step} />
			))}
		</Box>
	);
};
